import portfolios from "@/services/ecosystem/portfolios.service"

export default {
    state: {
        portfolios: [],
        portfoliosLoaded: false,
    },

    actions: {
        async fetchPortfolios({state}, reload = false){
            if (state.portfoliosLoaded && !reload) {
                return state.portfolios
            }

            const response = await portfolios.getList()
            state.portfolios = response.data
            state.portfoliosLoaded = true
        }
    },

    getters: {
        portfoliosList: state => state.portfolios,
    }
}
